/**
 * Utilitário centralizado para detecção de ambiente.
 * Usar SEMPRE este módulo em vez de checar import.meta.env diretamente.
 *
 * - isDevEnvironment(): true em localhost OU ambiente .dev.agendario.com.br
 * - isLocalhost(): true apenas em localhost
 * - isProduction(): true apenas no ambiente de produção (sem .dev.)
 */

export function isDevEnvironment() {
  return (
    import.meta.env.DEV ||
    import.meta.env.MODE === 'development' ||
    import.meta.env.VITE_API_URL?.includes('.dev.') ||
    window.location.hostname.includes('localhost') ||
    window.location.hostname.includes('.dev.')
  );
}

export function isLocalhost() {
  return (
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1'
  );
}

export function isProduction() {
  return !isDevEnvironment();
}
